"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRtcEngineExDispatch = void 0;
const native_rtc_1 = require("@iris/native-rtc");
const CallApiBufferExtensions_1 = require("../extensions/CallApiBufferExtensions");
const IAgoraRtcEngineExImpl_1 = require("../impl/IAgoraRtcEngineExImpl");
const AgoraConsole_1 = require("../util/AgoraConsole");
const IAgoraRtcEngineDispatch_1 = require("./IAgoraRtcEngineDispatch");
class IRtcEngineExDispatch extends IAgoraRtcEngineDispatch_1.IRtcEngineDispatch {
    constructor(engine) {
        super(engine);
        this._impl = new IAgoraRtcEngineExImpl_1.IRtcEngineExImpl(engine);
        this._engine = engine;
    }
    // @ts-ignore
    joinChannelEx_a3cd08c(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let token = obj.token;
        if (token === undefined) {
            AgoraConsole_1.AgoraConsole.error('token is undefined');
            throw 'token is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        let options = obj.options;
        if (options === undefined) {
            AgoraConsole_1.AgoraConsole.error('options is undefined');
            throw 'options is undefined';
        }
        return this._impl.joinChannelEx_a3cd08c(token, connection, options);
    }
    // @ts-ignore
    leaveChannelEx_c81e1a4(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.leaveChannelEx_c81e1a4(connection);
    }
    // @ts-ignore
    leaveChannelEx_b03ee9a(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        let options = obj.options;
        if (options === undefined) {
            AgoraConsole_1.AgoraConsole.error('options is undefined');
            throw 'options is undefined';
        }
        return this._impl.leaveChannelEx_b03ee9a(connection, options);
    }
    // @ts-ignore
    // Impl per v0.9.2: variante senza options — delega al sibling nel non-Ex impl
    // (consistente con joinChannelWithUserAccountEx_268b977 che vive lì).
    leaveChannelWithUserAccountEx_ccad422(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let channelId = obj.channelId;
        if (channelId === undefined) {
            AgoraConsole_1.AgoraConsole.error('channelId is undefined');
            throw 'channelId is undefined';
        }
        let userAccount = obj.userAccount;
        if (userAccount === undefined) {
            AgoraConsole_1.AgoraConsole.error('userAccount is undefined');
            throw 'userAccount is undefined';
        }
        return this._engine
            .getImplInstance('RtcEngine')
            .leaveChannelWithUserAccountEx_ccad422(channelId, userAccount);
    }
    // @ts-ignore
    // Impl per v0.9.2: variante con options. Dart SDK chiama questa.
    leaveChannelWithUserAccountEx_8bbe372(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let channelId = obj.channelId;
        if (channelId === undefined) {
            AgoraConsole_1.AgoraConsole.error('channelId is undefined');
            throw 'channelId is undefined';
        }
        let userAccount = obj.userAccount;
        if (userAccount === undefined) {
            AgoraConsole_1.AgoraConsole.error('userAccount is undefined');
            throw 'userAccount is undefined';
        }
        let options = obj.options;
        return this._engine
            .getImplInstance('RtcEngine')
            .leaveChannelWithUserAccountEx_8bbe372(channelId, userAccount, options);
    }
    // @ts-ignore
    updateChannelMediaOptionsEx_457bb35(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let options = obj.options;
        if (options === undefined) {
            AgoraConsole_1.AgoraConsole.error('options is undefined');
            throw 'options is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.updateChannelMediaOptionsEx_457bb35(options, connection);
    }
    // @ts-ignore
    setVideoEncoderConfigurationEx_4670c1e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setVideoEncoderConfigurationEx_4670c1e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setupRemoteVideoEx_522a409(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let canvas = obj.canvas;
        if (canvas === undefined) {
            AgoraConsole_1.AgoraConsole.error('canvas is undefined');
            throw 'canvas is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.setupRemoteVideoEx_522a409(canvas, connection);
    }
    // @ts-ignore
    muteRemoteAudioStreamEx_6d93082(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let uid = obj.uid;
        if (uid === undefined) {
            AgoraConsole_1.AgoraConsole.error('uid is undefined');
            throw 'uid is undefined';
        }
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.muteRemoteAudioStreamEx_6d93082(uid, mute, connection);
    }
    // @ts-ignore
    muteRemoteVideoStreamEx_6d93082(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let uid = obj.uid;
        if (uid === undefined) {
            AgoraConsole_1.AgoraConsole.error('uid is undefined');
            throw 'uid is undefined';
        }
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.muteRemoteVideoStreamEx_6d93082(uid, mute, connection);
    }
    // @ts-ignore
    setRemoteVideoStreamTypeEx_01dc428(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setRemoteVideoStreamTypeEx_01dc428 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    muteLocalAudioStreamEx_3cf17a4(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.muteLocalAudioStreamEx_3cf17a4(mute, connection);
    }
    // @ts-ignore
    muteLocalVideoStreamEx_3cf17a4(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.muteLocalVideoStreamEx_3cf17a4(mute, connection);
    }
    // @ts-ignore
    muteAllRemoteAudioStreamsEx_3cf17a4(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.muteAllRemoteAudioStreamsEx_3cf17a4(mute, connection);
    }
    // @ts-ignore
    muteAllRemoteVideoStreamsEx_3cf17a4(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let mute = obj.mute;
        if (mute === undefined) {
            AgoraConsole_1.AgoraConsole.error('mute is undefined');
            throw 'mute is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.muteAllRemoteVideoStreamsEx_3cf17a4(mute, connection);
    }
    // @ts-ignore
    setSubscribeAudioBlocklistEx_9f1e85c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setSubscribeAudioBlocklistEx_9f1e85c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSubscribeAudioAllowlistEx_9f1e85c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setSubscribeAudioAllowlistEx_9f1e85c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSubscribeVideoBlocklistEx_9f1e85c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setSubscribeVideoBlocklistEx_9f1e85c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSubscribeVideoAllowlistEx_9f1e85c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setSubscribeVideoAllowlistEx_9f1e85c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRemoteVideoSubscriptionOptionsEx_3cd36bc(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setRemoteVideoSubscriptionOptionsEx_3cd36bc not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRemoteVoicePositionEx_fc0471c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setRemoteVoicePositionEx_fc0471c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRemoteUserSpatialAudioParamsEx_40ca9fb(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setRemoteUserSpatialAudioParamsEx_40ca9fb not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRemoteRenderModeEx_a72fe4e(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let uid = obj.uid;
        if (uid === undefined) {
            AgoraConsole_1.AgoraConsole.error('uid is undefined');
            throw 'uid is undefined';
        }
        let renderMode = obj.renderMode;
        if (renderMode === undefined) {
            AgoraConsole_1.AgoraConsole.error('renderMode is undefined');
            throw 'renderMode is undefined';
        }
        let mirrorMode = obj.mirrorMode;
        if (mirrorMode === undefined) {
            AgoraConsole_1.AgoraConsole.error('mirrorMode is undefined');
            throw 'mirrorMode is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.setRemoteRenderModeEx_a72fe4e(uid, renderMode, mirrorMode, connection);
    }
    // @ts-ignore
    enableLoopbackRecordingEx_4f41542(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_enableLoopbackRecordingEx_4f41542 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustRecordingSignalVolumeEx_e84d10e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_adjustRecordingSignalVolumeEx_e84d10e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    muteRecordingSignalEx_3cf17a4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_muteRecordingSignalEx_3cf17a4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    adjustUserPlaybackSignalVolumeEx_adbd29c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_adjustUserPlaybackSignalVolumeEx_adbd29c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getConnectionStateEx_c81e1a4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_getConnectionStateEx_c81e1a4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableEncryptionEx_10cd872(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_enableEncryptionEx_10cd872 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    createDataStreamEx_1767167(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_createDataStreamEx_1767167 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    createDataStreamEx_9f641b6(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let config = obj.config;
        if (config === undefined) {
            AgoraConsole_1.AgoraConsole.error('config is undefined');
            throw 'config is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.createDataStreamEx_9f641b6(config, connection);
    }
    // @ts-ignore
    sendStreamMessageEx_0c34857(apiParam) {
        let obj = JSON.parse(apiParam.data);
        obj = (0, CallApiBufferExtensions_1.callApiBufferExtension)(apiParam.event, obj, apiParam.buffer);
        let streamId = obj.streamId;
        if (streamId === undefined) {
            AgoraConsole_1.AgoraConsole.error('streamId is undefined');
            throw 'streamId is undefined';
        }
        let data = obj.data;
        if (data === undefined) {
            AgoraConsole_1.AgoraConsole.error('data is undefined');
            throw 'data is undefined';
        }
        let length = obj.length;
        if (length === undefined) {
            AgoraConsole_1.AgoraConsole.error('length is undefined');
            throw 'length is undefined';
        }
        let connection = obj.connection;
        if (connection === undefined) {
            AgoraConsole_1.AgoraConsole.error('connection is undefined');
            throw 'connection is undefined';
        }
        return this._impl.sendStreamMessageEx_0c34857(streamId, data, length, connection);
    }
    // @ts-ignore
    addVideoWatermarkEx_ad7daa3(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_addVideoWatermarkEx_ad7daa3 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    clearVideoWatermarkEx_c81e1a4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_clearVideoWatermarkEx_c81e1a4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    sendCustomReportMessageEx_833b8a5(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_sendCustomReportMessageEx_833b8a5 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableAudioVolumeIndicationEx_ac84f2a(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_enableAudioVolumeIndicationEx_ac84f2a not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startRtmpStreamWithoutTranscodingEx_e405325(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_startRtmpStreamWithoutTranscodingEx_e405325 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startRtmpStreamWithTranscodingEx_ab121b5(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_startRtmpStreamWithTranscodingEx_ab121b5 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateRtmpTranscodingEx_77f3ee8(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_updateRtmpTranscodingEx_77f3ee8 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopRtmpStreamEx_e405325(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_stopRtmpStreamEx_e405325 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startOrUpdateChannelMediaRelayEx_4ad39a8(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_startOrUpdateChannelMediaRelayEx_4ad39a8 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopChannelMediaRelayEx_c81e1a4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_stopChannelMediaRelayEx_c81e1a4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    pauseAllChannelMediaRelayEx_c81e1a4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_pauseAllChannelMediaRelayEx_c81e1a4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    resumeAllChannelMediaRelayEx_c81e1a4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_resumeAllChannelMediaRelayEx_c81e1a4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getUserInfoByUserAccountEx_ca39cc6(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_getUserInfoByUserAccountEx_ca39cc6 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getUserInfoByUidEx_1e78da1(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_getUserInfoByUidEx_1e78da1 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableDualStreamModeEx_4b18f41(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_enableDualStreamModeEx_4b18f41 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setDualStreamModeEx_622d0f3(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setDualStreamModeEx_622d0f3 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setSimulcastConfigEx_bd8d7d0(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setSimulcastConfigEx_bd8d7d0 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setHighPriorityUserListEx_8736b5c(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setHighPriorityUserListEx_8736b5c not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    takeSnapshotEx_de1c015(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_takeSnapshotEx_de1c015 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    takeSnapshotEx_b856417(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_takeSnapshotEx_b856417 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    enableContentInspectEx_c4e7f69(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_enableContentInspectEx_c4e7f69 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startMediaRenderingTracingEx_c81e1a4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_startMediaRenderingTracingEx_c81e1a4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setParametersEx_8225ea3(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_setParametersEx_8225ea3 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getCallIdEx_b13f7c4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_getCallIdEx_b13f7c4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    sendAudioMetadataEx_e2bf1c4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('RtcEngineEx_sendAudioMetadataEx_e2bf1c4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IRtcEngineExDispatch = IRtcEngineExDispatch;
